// extracted by mini-css-extract-plugin
module.exports = {"root":"Home__root"};